import React from 'react'
import styled from './electronics.module.css'

function Content() {
  return (
    <div className={styled.Content}>
       <h5>Bengaluru</h5>      
        <p>
            Welcome to the Silicon Valley of India. Bengaluru has some of the world’s fastest growing companies, the best weather in the country
            and everything else that can make you call it home. Spread across the most convenient locations across the city, are some of the best residential
            facilities and office spaces.With Furlenco, you can rent furniture and appliances of your choice, and furnish your space.Be it bedroom, living room,
            dining room, balcony or the kids room - you’ll have everything your home needs.      
        </p>   
        <h5>Furlenco: Your furniture solution in Namma Bengaluru</h5>  
        <p>
            Is this the sofa I want? Can I afford this bed? Will this table last me a while? These are the kind of questions you’ll have when you start looking for furniture.
            Now, renting furniture might not be the first thing you’ll think of, but it has answers
            to all of your questions. What are they? You’ll find out if you keep reading.
            Bengaluru is now renting furniture      
        </p>  
    </div>
  )
}
export default Content